export default "__VITE_ASSET__B7n6hV2b__"